import app from '@/app';
import templateUrl from './gapIdentificationComments-detail.html';

/* @ngInject */
function Controller(
	$controller,
	GapIdentificationComments,
	$http,
  $uibModal,
	$timeout,
	AlertService,
	$state
) {
	const $ctrl = this;
	const resource = GapIdentificationComments;
  var planId;

	$controller('AbstractEntityDetailController', {
		$ctrl,
		resource: GapIdentificationComments,
		type: 'gapIdentificationComments'
	});

	var transition = $ctrl.transition;
	$ctrl.transition = params => {
		transition(params);
    planId = params.id;

		if (!$ctrl.entity) {
			$http.get('api/plans/' + params.id + '/segments', {}).then(function(response) {
				$ctrl.entity = response.data;
				$ctrl.params.id = params.id;
			});
		}
	};

  $ctrl.export = () => {
    var url = 'api/plans/exportGapIdentification?planId=' + planId;
    window.location.href = url;
  }

  $ctrl.showConfirmModal = () => {
    $ctrl.isConfirming = true;
  };
  
  $ctrl.cancelImport = () => {
    $ctrl.isConfirming = false;
  };

  $ctrl.upload = (files) => {
    $ctrl.isConfirming = false;
    if (!$ctrl.readonly && files && files.length) {
        var file = files[0];
        var reader = new FileReader();

        reader.onload = function(e) {
            var data = new Uint8Array(e.target.result);
            var workbook = XLSX.read(data, { type: 'array' });

            // Suponha que o conteúdo relevante esteja na primeira aba (sheet)
            var firstSheetName = workbook.SheetNames[0];
            var worksheet = workbook.Sheets[firstSheetName];

            // Converte o conteúdo da planilha para JSON
            var jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            // Processa o JSON para preencher o objeto $ctrl.entity
            var newEntities = jsonData.slice(3)
                .filter(function(row) { return row[0] != null && row[1] != null; })
                .map(function(row) {
                    return {
                        headMilestone: row[0],
                        tailMilestone: row[1],
                        comments: row[2],
                    };
                });

			// Validate that imported segments match exactly the exportable segments of this round
			var KM_TOLERANCE = 0.001;
			var kmEquals = function(a, b) { return Math.abs(a - b) < KM_TOLERANCE; };
			// Exclude zero-length segments (head === tail) — they are not included in the export
			var exportableSegments = ($ctrl.entity || []).filter(function(s) {
				return !kmEquals(s.headMilestone, s.tailMilestone);
			});

			if (newEntities.length !== exportableSegments.length) {
				AlertService.error('gap_identification_comments.import_segment_mismatch');
				return;
			}

			var hasInvalidSegment = newEntities.some(newEntity =>
				!exportableSegments.some(existingEntity =>
					kmEquals(existingEntity.headMilestone, newEntity.headMilestone) &&
					kmEquals(existingEntity.tailMilestone, newEntity.tailMilestone)
				)
			);

			if (hasInvalidSegment) {
				AlertService.error('gap_identification_comments.import_segment_mismatch');
				return;
			}

			$ctrl.entity = newEntities;

            // Força uma digestão para atualizar a tela
            $timeout(() => {
                // Isso garante que o AngularJS detecte e aplique as mudanças
            });
        };

        reader.readAsArrayBuffer(file);
    }
  };

	$ctrl.save = () => {
		$http
			.put('api/plans/' + $ctrl.state.params.id + '/segments', $ctrl.entity)
			.then(function(response) {
				if (response.status == 200) {
					AlertService.success('entity.update.message', {
						type: 'segments',
						name: 'Observações'
					});
					$ctrl.isSaving = false;
					$state.go('^', {}, { reload: true });
				} else {
					$ctrl.isSaving = false;
				}
			});
	};
}
const component = {
	templateUrl,
	controller: Controller,
	require: {
		parent: '^gapIdentificationResult'
	},
	bindings: {
		$transition$: '<'
	}
};

app.component('gapIdentificationEditComments', component);
